const sanitizeForID = (formerString) => (
  formerString.replace(/[^\w]/g, '-')
);

const sanitizeForHandle = (formerString) => (
  formerString.replace(/[^a-z]/gi, '').toLowerCase()
);

const removeSpaces = (str) => str.toLowerCase().replaceAll(' ', '');

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

/**
 * Turns a filename into a human-readable, title-cased name.
 * e.g. "Barbell-Back_Squat.mp4" -> "Barbell Back Squat"
 */
const filenameToTitle = (filename = '') => filename
  .replace(/\.[a-z0-9]+$/i, '') // drop extension
  .replace(/[-_]+/g, ' ') // separators to spaces
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/\b\w/g, (char) => char.toUpperCase());

export {
  sanitizeForID,
  sanitizeForHandle,
  removeSpaces,
  capitalizeFirstLetter,
  filenameToTitle,
};
